/**
 * TrackSidebarWrapper Component
 * Wrapper for the TrackSidebar with all required props for track management
 */

import React from 'react';
import { TrackSidebar } from './index';

export const TrackSidebarWrapper = ({
  showMixer,
  setShowMixer,
  isMobile,
  tracks,
  selectedTrack,
  setSelectedTrack,
  recordingTrack,
  isMidiRecording,
  effectiveMaxTracks,
  subscriptionTrackLimit,
  maxTracks,
  // Track operations
  addTrack,
  addInstrumentTrack,
  updateTrack,
  removeTrack,
  duplicateTrack,
  // Recording
  isRecording,
  startRecording,
  stopRecording,
  startMidiRecording,
  stopMidiRecording,
  handleFileImport,
  // Volume
  masterVolume,
  setMasterVolume,
  getFeatureLimit,
  // Drag & drop
  draggedTrackId,
  dragOverTrackId,
  dropPosition,
  handleDragStart,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleDragEnd,
  // Collaboration
  showCollaboration,
  collabUsers,
  currentUserId,
  // Navigation
  navigate,
}) => {
  return (
    <TrackSidebar
      isOpen={showMixer}
      onClose={() => setShowMixer(false)}
      isMobile={isMobile}
      tracks={tracks}
      selectedTrack={selectedTrack}
      setSelectedTrack={setSelectedTrack}
      recordingTrack={recordingTrack}
      isMidiRecording={isMidiRecording}
      effectiveMaxTracks={effectiveMaxTracks}
      subscriptionTrackLimit={subscriptionTrackLimit}
      maxTracks={maxTracks}
      addTrack={addTrack}
      addInstrumentTrack={addInstrumentTrack}
      updateTrack={updateTrack}
      removeTrack={removeTrack}
      duplicateTrack={duplicateTrack}
      isRecording={isRecording}
      startRecording={startRecording}
      stopRecording={stopRecording}
      startMidiRecording={startMidiRecording}
      stopMidiRecording={stopMidiRecording}
      handleFileImport={handleFileImport}
      masterVolume={masterVolume}
      setMasterVolume={setMasterVolume}
      getFeatureLimit={getFeatureLimit}
      draggedTrackId={draggedTrackId}
      dragOverTrackId={dragOverTrackId}
      dropPosition={dropPosition}
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onDragEnd={handleDragEnd}
      showCollaboration={showCollaboration}
      collabUsers={collabUsers}
      currentUserId={currentUserId}
      onCollabTrackSelect={(trackId) => {
        if (window.__collabSendTrackSelect) {
          window.__collabSendTrackSelect(trackId);
        }
      }}
      navigate={navigate}
    />
  );
};

export default TrackSidebarWrapper;
